import Footer from 'components/Footer'
import Header from 'components/Header'
import * as React from 'react'
import { Button } from 'react-bootstrap'

const SceneComponent: React.FC = () => {
  return (
    <>
      <Header title="有効期限切れ" />
      <main>
        <section className="mx-4 my-5">
          <div className="mt-5">
            <p>名義変更登録期間が終了いたしました。</p>
            <p>招待様へご連絡いただき、紹介用URLをご確認ください。</p>
          </div>
          <div className="mt-4">
            <Button variant="primary" className="w-100 py-4" href={'/login'}>
              ログイン画面へ戻る
            </Button>
          </div>
        </section>
      </main>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
